import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type INavigationConfigDBItem } from 'views/Settings/NavigationMap/types/types';

export interface NavigationConfigState {
  loading: boolean;
  data: INavigationConfigDBItem[];
}

const initialState: NavigationConfigState = {
  loading: true,
  data: [],
};

export const navigationConfigSlice = createSlice({
  name: 'navigationConfig',
  initialState,
  reducers: {
    setNavigationConfigLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setNavigationConfigData(
      state,
      action: PayloadAction<INavigationConfigDBItem[]>
    ) {
      state.data = action.payload;
    },
  },
});

export const { setNavigationConfigLoading, setNavigationConfigData } =
  navigationConfigSlice.actions;

export default navigationConfigSlice.reducer;
